export const getTrialRemainingTime = (
	createdAt: string | undefined,
	trialPeriod: number | undefined,
) => {
	if (!createdAt || !trialPeriod) return {}

	const countdownStartTime = new Date(createdAt)
	const currentDate = new Date()

	const expiresAt = new Date(
		countdownStartTime.getTime() + trialPeriod * 24 * 60 * 60 * 1000,
	)

	const expired = expiresAt.getTime() <= currentDate.getTime()

	if (expired) {
		return {
			expiresAt,
			expired,
			days: 0,
			hours: 0,
			minutes: 0,
			seconds: 0,
		}
	}

	const timeDifference = expiresAt.getTime() - currentDate.getTime()

	const days = Math.max(Math.floor(timeDifference / (1000 * 60 * 60 * 24)), 0)
	const hours = Math.max(
		Math.floor((timeDifference / (1000 * 60 * 60)) % 24),
		0,
	)
	const minutes = Math.max(Math.floor((timeDifference / (1000 * 60)) % 60), 0)
	const seconds = Math.max(Math.floor((timeDifference / 1000) % 60), 0)

	return {
		expiresAt,
		expired,
		days,
		hours,
		minutes,
		seconds,
	}
}
